export const ASSET_NAMES: Record<string, string> = {
  USDT: 'Tether',
  BTC: 'Bitcoin',
  BCH: 'Bitcoin Cash',
  USDC: 'USD Coin',
  ETH: 'Ethereum',
  SOL: 'Solana',
  DAI: 'Dai',
  EUR: 'Euro',
  EURC: 'Euro Coin'
};

export const NETWORK_DISPLAY_NAMES: Record<string, string> = {
  ERC20: 'ETHEREUM',
  TRC20: 'TRON'
};

export const getNetworkDisplayName = (network: string) =>
  NETWORK_DISPLAY_NAMES[network.toUpperCase()] ?? network;

export const ASSET_DECIMALS: Record<string, number> = {
  USDT: 6,
  BTC: 8,
  USDC: 6,
  ETH: 18,
  DAI: 18,
  EURC: 6,
  USD: 2,
  EUR: 2,
  JPY: 0,
  GBP: 2,
  CHF: 2,
  CAD: 2,
  AUD: 2,
  NZD: 2,
  CNY: 2,
  HKD: 2,
  SGD: 2,
  INR: 2,
  KRW: 0,
  SEK: 2,
  NOK: 2,
  DKK: 2
};

export const toSmallestAmount = (amount: string, asset?: string) => {
  if (amount === '' || !asset) return '';

  const decimals = ASSET_DECIMALS[asset] ?? 0;
  const [whole = '0', fraction = ''] = amount.split('.');
  const scaledFraction = fraction.padEnd(decimals, '0').slice(0, decimals);

  return `${whole}${scaledFraction}`.replace(/^0+(?=\d)/, '');
};

const ETH_CONFIG = {
  chainId: 1,
  tokenContracts: {
    USDT: {
      address: '0xdAC17F958D2ee523a2206206994597C13D831ec7',
      decimals: ASSET_DECIMALS.USDT
    },
    USDC: {
      address: '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
      decimals: ASSET_DECIMALS.USDC
    }
  }
};

export const CHAIN_CONFIG: Record<
  string,
  {
    chainId: number;
    tokenContracts: Record<string, { address: string; decimals: number }>;
  }
> = {
  ethereum: ETH_CONFIG,
  eth: ETH_CONFIG,
  erc20: ETH_CONFIG,
  binance: {
    chainId: 56,
    tokenContracts: {
      USDT: {
        address: '0x55d398326f99059fF775485246999027B3197955',
        decimals: ASSET_DECIMALS.USDT
      },
      USDC: {
        address: '0x8AC76a51cc950d9822D68b83fE1Ad97B32Cd580d',
        decimals: ASSET_DECIMALS.USDC
      }
    }
  },
  base: {
    chainId: 8453,
    tokenContracts: {
      USDT: {
        address: '0xfde4C96c8593536E31F229EA8f37b2ADa2699bb2',
        decimals: ASSET_DECIMALS.USDT
      },
      USDC: {
        address: '0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913',
        decimals: ASSET_DECIMALS.USDC
      }
    }
  },
  arbitrum: {
    chainId: 42161,
    tokenContracts: {
      USDT: {
        address: '0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9',
        decimals: ASSET_DECIMALS.USDT
      },
      USDC: {
        address: '0xaf88d065e77c8cC2239327C5EDb3A432268e5831',
        decimals: ASSET_DECIMALS.USDC
      }
    }
  },
  sepolia: {
    chainId: 11155111,
    tokenContracts: {
      USDT: {
        address: '0x3429519eE7cDbB13B49161F1Eb6e1B026939113A',
        decimals: ASSET_DECIMALS.USDT
      },
      USDC: {
        address: '0x1c7D4B196Cb0C7B01d743Fbc6116a902379C7238',
        decimals: ASSET_DECIMALS.USDC
      }
    }
  }
};
